import { OrderHeadersGroupBy, OrderHeadersGroupByEnum } from '../../orderProducts.types';
import OrderProductsBuilder from './OrderProductsGroupBuilder';
import OrderProductsGroupByCategory from './OrderProductsGroupByCategory';
import OrderProductsGroupByCollection from './OrderProductsGroupByCollection';
import OrderProductsGroupByColorClassifications from './OrderProductsGroupByColorClassifications';
import OrderProductsGroupByDefault from './OrderProductsGroupByDefault';
import OrderProductsGroupByDeliveryWindow from './OrderProductsGroupByDeliveryWindow';
import OrderProductsGroupByMultiple from './OrderProductsGroupByMultiple';
import OrderProductsGroupByPendency from './OrderProductsGroupByPendency';
import OrderProductsGroupByProduct from './OrderProductsGroupByProduct';
import OrderProductsGroupBySubCategory from './OrderProductsGroupBySubCategory';

export default class OrderProductsGroupByFactory {
  create(view: OrderHeadersGroupBy[]): OrderProductsBuilder {
    const [firstView, secondView] = view;
    if (secondView) {
      return new OrderProductsGroupByMultiple(view);
    }
    switch (firstView) {
      case OrderHeadersGroupByEnum.DELIVERY_WINDOW:
        return new OrderProductsGroupByDeliveryWindow();
      case OrderHeadersGroupByEnum.COLLECTION:
        return new OrderProductsGroupByCollection();
      case OrderHeadersGroupByEnum.CATEGORY:
        return new OrderProductsGroupByCategory();
      case OrderHeadersGroupByEnum.SUB_CATEGORY:
        return new OrderProductsGroupBySubCategory();
      case OrderHeadersGroupByEnum.PRODUCT:
        return new OrderProductsGroupByProduct();
      case OrderHeadersGroupByEnum.COLOR_CLASSIFICATION_TYPE:
        return new OrderProductsGroupByColorClassifications();
      case OrderHeadersGroupByEnum.PENDENCY:
        return new OrderProductsGroupByPendency();
      case OrderHeadersGroupByEnum.DEFAULT:
      default:
        return new OrderProductsGroupByDefault();
    }
  }
}
